// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1exT3","messages":"Chat_messages__3nhPc","dateDivider":"Chat_dateDivider__1HNfR"};